// 调理方法模块（商业版）

const SEASON_LABELS = { '春': '春季', '夏': '夏季', '秋': '秋季', '冬': '冬季' };

// 四立节气精确日期表（公历月-日），由天文历表生成，覆盖 2020-2060
// 顺序：[立春, 立夏, 立秋, 立冬]
const JIEQI_TABLE = {
    2020: [[2,4],[5,5],[8,7],[11,7]],
    2021: [[2,3],[5,5],[8,7],[11,7]],
    2022: [[2,4],[5,5],[8,7],[11,7]],
    2023: [[2,4],[5,6],[8,8],[11,8]],
    2024: [[2,4],[5,5],[8,7],[11,7]],
    2025: [[2,3],[5,5],[8,7],[11,7]],
    2026: [[2,4],[5,5],[8,7],[11,7]],
    2027: [[2,4],[5,6],[8,8],[11,7]],
    2028: [[2,4],[5,5],[8,7],[11,7]],
    2029: [[2,3],[5,5],[8,7],[11,7]],
    2030: [[2,4],[5,5],[8,7],[11,7]],
    2031: [[2,4],[5,6],[8,8],[11,7]],
    2032: [[2,4],[5,5],[8,7],[11,7]],
    2033: [[2,3],[5,5],[8,7],[11,7]],
    2034: [[2,4],[5,5],[8,7],[11,7]],
    2035: [[2,4],[5,5],[8,7],[11,7]],
    2036: [[2,4],[5,5],[8,7],[11,7]],
    2037: [[2,3],[5,5],[8,7],[11,7]],
    2038: [[2,4],[5,5],[8,7],[11,7]],
    2039: [[2,4],[5,5],[8,7],[11,7]],
    2040: [[2,4],[5,5],[8,7],[11,7]],
    2041: [[2,3],[5,5],[8,7],[11,7]],
    2042: [[2,4],[5,5],[8,7],[11,7]],
    2043: [[2,4],[5,5],[8,7],[11,7]],
    2044: [[2,4],[5,5],[8,7],[11,7]],
    2045: [[2,3],[5,5],[8,7],[11,7]],
    2046: [[2,4],[5,5],[8,7],[11,7]],
    2047: [[2,4],[5,5],[8,7],[11,7]],
    2048: [[2,4],[5,5],[8,7],[11,7]],
    2049: [[2,3],[5,5],[8,7],[11,7]],
    2050: [[2,3],[5,5],[8,7],[11,7]],
    2051: [[2,4],[5,5],[8,7],[11,7]],
    2052: [[2,4],[5,5],[8,7],[11,7]],
    2053: [[2,3],[5,5],[8,7],[11,7]],
    2054: [[2,3],[5,5],[8,7],[11,7]],
    2055: [[2,4],[5,5],[8,7],[11,7]],
    2056: [[2,4],[5,5],[8,7],[11,7]],
    2057: [[2,3],[5,5],[8,7],[11,7]],
    2058: [[2,3],[5,5],[8,7],[11,7]],
    2059: [[2,4],[5,5],[8,7],[11,7]],
    2060: [[2,4],[5,5],[8,7],[11,6]],
};

function pad2(n) { return n < 10 ? '0' + n : '' + n; }

function toYmd(date) {
    return date.getFullYear() + '-' + pad2(date.getMonth() + 1) + '-' + pad2(date.getDate());
}

function addDays(ymd, delta) {
    const [y, m, d] = ymd.split('-').map(Number);
    const dt = new Date(y, m - 1, d + delta);
    return toYmd(dt);
}

function getSeasonBoundaries(year) {
    const row = JIEQI_TABLE[year];
    if (!row) throw new Error(`节气数据未覆盖 ${year} 年（支持 2020-2060）`);
    const [lc, lx, lq, ld] = row;
    return {
        liChun: `${year}-${pad2(lc[0])}-${pad2(lc[1])}`,
        liXia:  `${year}-${pad2(lx[0])}-${pad2(lx[1])}`,
        liQiu:  `${year}-${pad2(lq[0])}-${pad2(lq[1])}`,
        liDong: `${year}-${pad2(ld[0])}-${pad2(ld[1])}`,
    };
}

function formatCnYmd(ymd) {
    const [, mm, dd] = ymd.split('-');
    return `${parseInt(mm, 10)}月${parseInt(dd, 10)}日`;
}

function formatSeasonRange(startYmd, endYmd) {
    const [ys] = startYmd.split('-').map(Number);
    const [ye] = endYmd.split('-').map(Number);
    if (ys === ye) return `${formatCnYmd(startYmd)}—${formatCnYmd(endYmd)}`;
    return `${ys}年${formatCnYmd(startYmd)}—${ye}年${formatCnYmd(endYmd)}`;
}

/**
 * @returns {{ season: '春'|'夏'|'秋'|'冬', currentSeason: string }}
 */
function resolveSeasonForReport(date = new Date()) {
    const ymd = toYmd(date);
    const y = date.getFullYear();
    const b = getSeasonBoundaries(y);
    const prevB = getSeasonBoundaries(y - 1);
    const nextB = getSeasonBoundaries(y + 1);

    let season, startYmd, endYmdInclusive;

    if (ymd < b.liChun) {
        season = '冬';
        startYmd = prevB.liDong;
        endYmdInclusive = addDays(b.liChun, -1);
    } else if (ymd < b.liXia) {
        season = '春';
        startYmd = b.liChun;
        endYmdInclusive = addDays(b.liXia, -1);
    } else if (ymd < b.liQiu) {
        season = '夏';
        startYmd = b.liXia;
        endYmdInclusive = addDays(b.liQiu, -1);
    } else if (ymd < b.liDong) {
        season = '秋';
        startYmd = b.liQiu;
        endYmdInclusive = addDays(b.liDong, -1);
    } else {
        season = '冬';
        startYmd = b.liDong;
        endYmdInclusive = addDays(nextB.liChun, -1);
    }

    const range = formatSeasonRange(startYmd, endYmdInclusive);
    const currentSeason = `${SEASON_LABELS[season]}（${range}）`;

    return { season, currentSeason };
}

export default function transform(data) {
    if (!data) return;
    const moduleList = data.module_list_shangye;
    if (!Array.isArray(moduleList)) return;

    const { season, currentSeason } = resolveSeasonForReport();

    data.adjustmentFunList = moduleList
        .filter(mod => mod.is_show === 1)
        .map(mod => {
            const descList = mod.description_list;
            if (!descList || typeof descList !== 'object') return null;

            const allItems = [];
            for (const key of Object.keys(descList)) {
                const desc = descList[key];
                if (!desc || !Array.isArray(desc.list)) continue;
                for (const item of desc.list) {
                    if (!Array.isArray(item.module_value)) continue;
                    const seasonVal = item.module_value.find(v => v.title === '适用季节' || v.title === '适应季节');
                    if (seasonVal && seasonVal.value === season) {
                        allItems.push(item);
                    }
                }
            }

            if (allItems.length === 0) return null;

            return {
                moduleName: mod.module_name,
                items: allItems.map(item => ({
                    values: item.module_value.filter(v => v.title !== '适用季节' && v.title !== '适应季节')
                }))
            };
        })
        .filter(Boolean);

    data.currentSeason = currentSeason;
}
